import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { useAuth } from '../../../contexts/userContext/userContext';
import { useModal } from '../../../contexts/modalsContext/modalsContext';
import { editLegalCustomer, editPhysicalCustomer } from '../../../../services/customer/profileServices';
import EditProfileModal from '../modals/editProfileModal/EditProfileModal';
import EditProfileDrawer from '../drawers/editProfileDrawer/EditProfileDrawer';
import useTranslation from '../../../hooks/translation/useTranslation';

function EditProfile({ formOptions }) {
  const { user, getCurrentUser } = useAuth();
  const { setShowEditProfile, showEditProfile } = useModal();
  const [errors, setErrors] = useState({});
  const [form] = Form.useForm();

  const { trans, configInfo } = useTranslation();

  const isGeorgian = configInfo?.countryCode === 'GE';

  const handleSubmit = async (values) => {
    setErrors({});
    if (values.phone_number) {
      // eslint-disable-next-line no-param-reassign
      values.phone_number = values.phone_number.replace(/\s/g, '');
    }
    try {
      if (
        isGeorgian && values?.phone_number !== user?.phone_number && values?.verified !== 'phone_number'
      ) {
        form.setFields([
          {
            name: 'phone_number',
            errors: [trans('validation_necessary')],
          },
        ]);
      } else {
        const res = await (
          user?.type === 'physical'
            ? editPhysicalCustomer(values)
            : editLegalCustomer(values)
        );
        if (res.status === 'success') {
          await getCurrentUser();
          setShowEditProfile(false);
        }
      }
    } catch (error) {
      setErrors(error.response.data.errors);
    }
  };

  useEffect(() => {
    if (user?.id && formOptions) {
      form.setFieldsValue({
        ...user,
        country_phone_code: user?.country_phone_code || 1,
        verification: user?.email_verified || user?.type === 'physical' ? 2 : 1,
        ...(
          (user?.personal_number || user?.passport_number)
            ? { id_number: user?.personal_number || user?.passport_number }
            : {}),
      });
    }
  }, [user, formOptions]);
  return (
    <>
      <EditProfileModal
        form={form}
        errors={errors}
        handleSubmit={handleSubmit}
        formOptions={formOptions}
        setShowEditProfile={setShowEditProfile}
        showEditProfile={showEditProfile}
        setErrors={setErrors}
      />
      <EditProfileDrawer
        form={form}
        errors={errors}
        handleSubmit={handleSubmit}
        formOptions={formOptions}
        setShowEditProfile={setShowEditProfile}
        showEditProfile={showEditProfile}
      />
    </>
  );
}

export default EditProfile;
